import React from "react";
import { Button } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { withRouter } from 'react-router'
import NativeDropDown from "../../../SharedModules/Dropdowns/OrgNativeDropDown";
import AddOrganization from "../Components/AddOrganization";
import { dispatchResetOrg } from "../action";
import {
  CMdSPortals
} from "../../../SharedModules/AppConstants";
import { userLogout } from "../../../SharedModules/Store/Actions/SharedAction";
import {navigateToCMdSApp} from '../../../SharedModules/utility/utilityFunction';

function LandingPage(props) {
  const dispatch = useDispatch();
  const orgListDetails = localStorage.getItem("orgList");
  const checked = localStorage.getItem("Checked");
  const dropdownValues = orgListDetails?.length
    ? JSON.parse(orgListDetails)
    : [];
  const [errorMessages, setErrorMessages] = React.useState([]);
  const [successMessages, setSuccessMessages] = React.useState([]);
  const [landingPage, setLandingPage] = React.useState(false);
  const [showAddOrg, setShowAddOrg] = React.useState(false);
  let userData = JSON.parse(localStorage.getItem("loginState"));
  const url = process.env.REACT_APP_WP_URL;
  const [orgValues, setOrgValues] = React.useState({
    providerMedicaidID: "",
    providerNPI: "",
    providerEINSSN: "",
    providerZipCode: "",
    userRegister: "registerProvider",
  });
  const onReset = () => dispatch(dispatchResetOrg());
  const getUrl = (h) => {
    const accessToken = localStorage.getItem('accessToken');
    const refreshToken = localStorage.getItem('refreshToken');
    const username = localStorage.getItem('username');
    const impStateLoginInd = localStorage.getItem('impStateLoginInd');
    const orgID = localStorage.getItem("orgID");
    const orgName = localStorage.getItem("orgName");
    const npiId = localStorage.getItem("npiId");
    const newUrl = navigateToCMdSApp(h, username, accessToken, refreshToken, impStateLoginInd, orgID, orgName, npiId);
    return newUrl
  };

  const addOrganization = () => {
    setShowAddOrg(true);
    onReset();
    setOrgValues({
      providerEINSSN: "",
      providerMedicaidID: "",
      providerZipCode: "",
      providerNPI: "",
      userRegister: "registerProvider",
    });
  };

  const [values, setValues] = React.useState({
    organizationId: "-1",
  });

  const getNPI =(org)=>{
    const filteredList = dropdownValues?.filter(e =>{
      if(e.orgId === org){
        return e
      }})
    return filteredList?.[0]?.npiId || ''
  }

  const handleChange = (name) => (event) => {
    setValues({ ...values, [name]: event.target.value });
    if (values !== "-1") {
      localStorage.setItem("orgID", event.target.value?.split("-")[0].trim());
      localStorage.setItem("orgName", event.target.value?.split("-")[1].trim());
      localStorage.setItem('npiId', getNPI(event.target.value?.split("-")[0].trim()))
      openTab(getUrl(url), "_blank");
      setValues({
        organizationId: "-1",
      });
    }
  };

  // // To remove search Params generated from login portal
  React.useEffect(() => {
    props.history?.replace({
      pathname: props.location.pathname,
      search: "",
    });
  }, []);

const makeTabActive = () => {
  if(process.env.REACT_APP_LOGIN_THROUGH === 'PRODUCT'){
    const tabToActivate = window.open(
      process.env.REACT_APP_PRODUCT_URL,
      CMdSPortals
    ); // env file product dev
    if (!tabToActivate.closed) {
      tabToActivate.focus();
    }
  }else{
    dispatch(userLogout())
  }
  };

  const getLWN = () => {
    return JSON.parse(localStorage.getItem("localWindowName") || "[]");
  };

  const openTab = (url, target, closeTabOnLogout = false) => {
    const wn = new Date().getTime().toString();
    const openedWindow = window.open(url, wn);
    if (!closeTabOnLogout && openedWindow) {
      let lwn = getLWN();
      lwn.push(wn);
      localStorage.setItem("localWindowName", JSON.stringify(lwn));
    }
  };

  return (
    <>
      <main className="before-login ">
        {successMessages.length > 0 ? (
          <div className="alert alert-success custom-alert" role="alert">
            {successMessages.map((message) => (
              <li>{message}</li>
            ))}
          </div>
        ) : null}
        {errorMessages.length > 0 ? (
          <div className="alert alert-danger custom-alert" role="alert">
            {errorMessages.map((message) => (
              <li>{message}</li>
            ))}
          </div>
        ) : null}
        <div
          className={`normallogin-container ${
            checked && window.name != CMdSPortals && "main-body"
          }`}
        >
          <div className="container-fluid h-100">
            <div className="row h-100 white-bg">
              <section className="col-lg-8 col-md-6 col-sm-12 banner-panel">
                <div className="log-courosal">
                  <div className="log-banner">
                    <img
                      title="Login Banner"
                      src="./images/banner.png"
                      alt="login image"
                    />
                  </div>
                </div>
              </section>
              <section className="col-lg-4 col-md-6 col-sm-12 portal-panel">
                <div className="portal-wrapper">
                  <div className="set-logOut">
                    <div className="welcome-user">
                      <h1>
                        Hello{" "}
                        {userData?.lastName && userData?.firstName
                          ? userData.lastName + " " + userData?.firstName
                          : ""}
                        !
                      </h1>
                    </div>
                    {!showAddOrg ? (
                      <>
                        {dropdownValues && dropdownValues?.length > 0 && (
                          <div className="set-logOut">
                            <div className="welcome-user">
                              <div className="landing-page  text-center">
                                <p className="heading-text">
                                  Select a Provider Organization ID to access Portal Home Page.
                                </p>
                                <NativeDropDown
                                  id="user-prefix"
                                  className="custom-input-select_LP"
                                  InputLabelProps={{
                                    shrink: true,
                                  }}
                                  value={values.organizationId}
                                  onChange={handleChange("organizationId")}
                                  dropdownList={
                                    dropdownValues &&
                                    dropdownValues.length > 0 &&
                                    dropdownValues.map((each) => (
                                      <option
                                        selected
                                        key={each.orgId}
                                        value={`${each.orgId}-${each.name}`}
                                      >
                                        {each.orgId} - {each.name}
                                      </option>
                                    ))
                                  }
                                />
                              </div>
                            </div>
                          </div>
                        )}
                        <br />
                        <div className="set-logOut">
                          <div className="welcome-user">
                            <div className="landing-page text-center">
                              <p className="heading-text">
                                To register a new enrolled Provider Organization for Portal access, click below.
                              </p>
                              <Button
                                title="Add Organization"
                                variant="outlined"
                                color="primary"
                                className="btn btn-ic btn-add addOrg-btn"
                                onClick={addOrganization}
                              >
                                Add Organization
                              </Button>
                            </div>
                          </div>
                        </div>
                      </>
                    ) : (
                      <>
                        <AddOrganization
                          setShowAddOrg={setShowAddOrg}
                          landingPage={landingPage}
                          setLandingPage={setLandingPage}
                          setSuccessMessages={setSuccessMessages}
                          setErrorMessages={setErrorMessages}
                          setOrgValues={setOrgValues}
                          orgValues={orgValues}
                        />
                      </>
                    )}
                  </div>
                  {!showAddOrg ? (
                    <>
                      <div className="user-logout text-center">
                        <div
                          className="logOut-btn mr-3"
                          onClick={makeTabActive}
                        >
                          <span className="my-home"></span>
                          Home
                        </div>
                      </div>
                    </>
                  ) : (
                    ""
                  )}
                </div>
              </section>
            </div>
          </div>
        </div>
      </main>
    </>
  );
}
export default withRouter(LandingPage);
